import React from "react";
import { Container } from "@material-ui/core";
import styled from "styled-components";
import Layout from "../Shared/Layout";
import { Trans } from "../utils/i18n";
import { Inertia } from "@inertiajs/inertia";
import {useForm, usePage} from "@inertiajs/inertia-react";
import MuiButton from "@material-ui/core/Button";
import { Field, Form as FinalForm } from "react-final-form";
import Select from "../Shared/Select";
import { getCookieValue } from "../utils/getCookieValue";
import { Alert } from "@material-ui/lab";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MuiSelect from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import InfoIcon from "@mui/icons-material/Info";
import {CheckCircle} from "@material-ui/icons";

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`;

export default function OrderCancelPage({
    order,
    secret,
    canCancelOrder,
    isOrderCanceled,
    feedbacks,
}) {
    const {
        props: { flash },
    } = usePage();
    const { data, setData, post, processing, errors } = useForm({
        cancellation_reason: '',
    });

    const onSubmit = async (event) => {
        event.preventDefault();
        post(route("order.cancel", [secret]), {
            data,
        });
    };
    const orderNumber = order.number;

    return (
        <Wrapper>
            <Container maxWidth="md">
                {isOrderCanceled ? (
                    <div className={'flex flex-col justify-center items-center mt-9'}>
                        <div className={'text-green-400 font-2xl'}>
                            <CheckCircle className="!h-16 !w-16 text-green-400"  aria-hidden="true"  />
                        </div>

                        <p className={'text-xl max-w-lg text-center mb-3'}>
                            <Trans i18nKey="order.cancel.order_number.canceled" orderNumber={orderNumber}>
                                Order <strong>"{{ orderNumber }}"</strong> canceled successfully.
                            </Trans>
                        </p>

                        {
                            order.has_checkout &&
                            <p className={'max-w-lg text-center mt-0'}>
                                <Trans i18nKey="order.cancel.depositInDays">
                                    Your refunded amount will be deposit in 5-10 business days.
                                </Trans>
                            </p>
                        }
                    </div>
                ) : canCancelOrder ? (
                    <p>
                        <Trans i18nKey="order.cancel.cancel_order">
                            Cancel the Order number
                        </Trans>
                        <strong>{" " + order.number + " "}</strong>
                        <Trans i18nKey="order.cancel.refund_diagnostic_fee">
                            and refund the diagnostic fee:
                        </Trans>
                    </p>
                ) : (
                    <div className={'flex flex-col justify-center items-center mt-9'}>
                        <div className={'text-yellow-500 '}>
                            <InfoIcon className={'!text-5xl'} />
                        </div>

                        <p className={'text-xl max-w-lg text-center mb-3'}>
                            <Trans i18nKey="order.cancel.cannot_cancel">
                                You cannot cancel Order number
                            </Trans>
                            <strong>{" " + order.number + " "}</strong>
                            <Trans i18nKey="order.cancel.in_process">
                                , because it is already in progress.
                            </Trans>
                        </p>
                    </div>
                )}

                {canCancelOrder && !isOrderCanceled && (
                    <form onSubmit={onSubmit}>
                        <FormControl
                            variant={"outlined"}
                            size={'small'}
                        >
                            <InputLabel
                                size={'small'}
                                htmlFor={'selectcancellation_reason'}>
                                <Trans i18nKey="order.cancel.cancelation_reason">
                                    Cancelation Reason
                                </Trans>
                            </InputLabel>
                            <MuiSelect
                                size={'small'}
                                name={'cancellation_reason'}
                                id={'selectcancellation_reason' }
                                native
                                label={
                                    <Trans i18nKey="order.cancel.cancelation_reason">
                                        Cancelation Reason
                                    </Trans>
                                }
                                onChange={e => setData('cancellation_reason', e.target.value)}
                            >
                                <option aria-label={<Trans i18nKey="select.none">None</Trans>} value="" />
                                {
                                    feedbacks
                                        .map((item, index) => (
                                            <option key={index} value={item}>{item}</option>
                                        ))
                                }
                            </MuiSelect>
                        </FormControl>
                        <div className={'mt-6'}>
                            <MuiButton
                                variant="contained"
                                color={"secondary"}
                                type={"submit"}
                                disabled={processing || !data.cancellation_reason}
                            >
                                <Trans i18nKey="queueDetail.canceAndRefund">
                                    Cancel and Refund
                                </Trans>
                            </MuiButton>
                        </div>
                        <div className={'mt-6'}>
                            {
                                flash.warning &&
                                <Alert severity="error">
                                    {
                                        flash.warning
                                    }
                                </Alert>
                            }
                        </div>
                    </form>
                )}
            </Container>
        </Wrapper>
    );
}

OrderCancelPage.layout = (page) => <Layout children={page} />;
